import { useBoardStore } from '../../../stores/boardStore';
import { FinanceItem } from '../../../lib/api/boards';

export const useBoardChartData = () => {
    const finance = useBoardStore((state) => state.finance);
    const events = useBoardStore((state) => state.events);
    const dateRange = useBoardStore((state) => state.dateRange);
    const currencySettings = useBoardStore((state) => state.currencySettings);
    const selectedEntities = useBoardStore((state) => state.selectedEntities);
    const channels = useBoardStore((state) => state.channels);
    const entities = useBoardStore((state) => state.entities);
    const journals = useBoardStore((state) => state.journals);
    const specs = useBoardStore((state) => state.specs);
    const isDataLoading = useBoardStore((state) => state.isDataLoading);

    const getCategoryTotals = (category: string) => {
        if (!finance || !finance.breakdown) {
            return { totalRevenues: 0, totalExpenses: 0, total: 0, items: [] as FinanceItem[] };
        }
        const items = finance.breakdown.filter(item => item.category === category);
        const totalRevenues = items.filter(i => i.type === 'REVENUE').reduce((sum, i) => sum + (Number(i.value) || 0), 0);
        const totalExpenses = items.filter(i => i.type === 'EXPENSE').reduce((sum, i) => sum + Math.abs(Number(i.value) || 0), 0);
        return {
            totalRevenues,
            totalExpenses,
            total: totalRevenues - totalExpenses,
            items
        };
    };

    return {
        finance,
        events,
        dateRange,
        currencySettings,
        selectedEntities,
        channels,
        entities,
        journals,
        specs,
        isLoading: isDataLoading,
        getCategoryTotals
    };
};
